import type { MapSlotDef } from '@/gameplay/types'

/** Регулярная прямоугольная решётка, 8-connected. */
export function rectGridSlots(
  cols: number,
  rows: number,
  originX: number,
  originZ: number,
  step: number,
): MapSlotDef[] {
  const cells: Array<{ c: number; r: number }> = []
  for (let r = 0; r < rows; r += 1) {
    for (let c = 0; c < cols; c += 1) {
      cells.push({ c, r })
    }
  }
  return latticeSlots(cells, originX, originZ, step)
}

/**
 * Маска рядов: '#' = слот, иное = пусто.
 * Соседи только среди существующих клеток, 8-connected.
 */
export function maskGridSlots(
  mask: string[],
  originX: number,
  originZ: number,
  step: number,
): MapSlotDef[] {
  const cells: Array<{ c: number; r: number }> = []
  for (let r = 0; r < mask.length; r += 1) {
    const row = mask[r]!
    for (let c = 0; c < row.length; c += 1) {
      if (row[c] === '#') cells.push({ c, r })
    }
  }
  return latticeSlots(cells, originX, originZ, step)
}

function latticeSlots(
  cells: Array<{ c: number; r: number }>,
  originX: number,
  originZ: number,
  step: number,
): MapSlotDef[] {
  const idAt = (c: number, r: number) => `c${c}_r${r}`
  const present = new Set(cells.map((cell) => idAt(cell.c, cell.r)))

  return cells.map(({ c, r }) => {
    const neighborIds: string[] = []
    for (let dr = -1; dr <= 1; dr += 1) {
      for (let dc = -1; dc <= 1; dc += 1) {
        if (dr === 0 && dc === 0) continue
        const nid = idAt(c + dc, r + dr)
        if (present.has(nid)) neighborIds.push(nid)
      }
    }
    return {
      id: idAt(c, r),
      position: { x: originX + c * step, y: 0.05, z: originZ + r * step },
      neighborIds,
    }
  })
}
